import "../../../design/templates.css";
import { Container } from "react-bootstrap";
import { templatesArray } from "../../../helper/templatesArray";
import { useState } from "react";
import { useDisclosure } from "@chakra-ui/react";
import TemplatesModal from "../../modals/templates_modal/TemplatesModal";

export default function Templates() {
    const [project, setProject] = useState({});
    const { isOpen, onOpen, onClose } = useDisclosure();

    const handleOpenModal = (item) => {
        setProject(item);
        onOpen();
    };

    return (
        <Container className="templateGallery">
            <div className="templateHeader">
                <div className="templateTitleWrapper">
                    <h1 className="templateTitleName">Premium</h1>
                    <h1 className="templateTitleAccent">Templates</h1>
                </div>
                <p className="templateHeaderSubtitle">Hand-crafted designs for modern businesses.</p>
            </div>

            <div className="templateZigzagContainer">
                {templatesArray.map((item, index) => {
                    const isEven = index % 2 === 0;
                    return (
                        <div
                            key={index}
                            className={`templateZigzagRow ${isEven ? "templateRowStandard" : "templateRowReverse"}`}
                        >
                            <div className="templateZigzagNumber">{index + 1}</div>

                            <div className="templateZigzagText">
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                                <button className="templateViewBtn" onClick={() => handleOpenModal(item)}>
                                    Explore Design
                                </button>
                            </div>

                            <div className="templateZigzagLine" />

                            <div className="templateZigzagImage" onClick={() => handleOpenModal(item)}>
                                <div className="templateImageInner">
                                    <img src={item.laptopImage} alt={item.title} />
                                    <div className="templateOverlay">
                                        <span>Click to Expand</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <TemplatesModal isOpen={isOpen} onClose={onClose} project={project} />
        </Container>
    );
}